import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

export default function ScreeningCancel() {
  return (
    <Box maxWidth={480} mx="auto" mt={6} px={2} textAlign="center">
      <CancelIcon color="action" sx={{ fontSize: 64, mb: 2 }} />
      <Typography variant="h5" gutterBottom>
        Payment cancelled
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        You cancelled the payment. You can request screening again from the invite link when you’re ready.
      </Typography>
      <Button variant="contained" href="/" sx={{ mt: 2 }}>
        Return to app
      </Button>
    </Box>
  );
}
